import { useState } from 'react';

import { createContexts } from '@/js/libs/create-contexts/index.ts';

export const { usePuzzleNavigationContext } = createContexts({
  PuzzleNavigation({ isCollapsedNav, collapseMainNav }: { isCollapsedNav: boolean; collapseMainNav: () => void }) {
    const [activeKey, setActiveKey] = useState<string | null>(null);

    return {
      activeKey,
      setActiveKey,
      isCollapsedNav,
      collapseMainNav,
    };
  },
});
